export default function Header() {
  return (
    <header>
      <h1 className="app-header">Seat Map Demo</h1>
    </header>
  )
}